import React, { useState, useEffect } from 'react';
import Header from '../components/landing/Header';
import TopBar from '../components/landing/TopBar';
import Footer from '../components/landing/Footer';
import EnquiryModal from '../components/landing/EnquiryModal';
import NoticeBoard from '../components/landing/NoticeBoard';
import api from '../utils/axios';

const Notice = () => {
    const [isScrolled, setIsScrolled] = useState(false);
    const [isInquiryOpen, setIsInquiryOpen] = useState(false);
    const [content, setContent] = useState({});

    useEffect(() => {
        window.scrollTo(0, 0);
        const handleScroll = () => setIsScrolled(window.scrollY > 50);
        window.addEventListener('scroll', handleScroll);
        fetchContent();
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const fetchContent = async () => {
        try {
            const res = await api.get('/content');
            const contentMap = {};
            res.data.data.forEach(item => {
                contentMap[item.key] = item.value;
            });
            setContent(contentMap);
        } catch (err) {
            console.error("Failed to load web content", err);
        }
    };

    return (
        <div className="min-h-screen bg-slate-50 font-sans text-slate-900">
            {!isScrolled && <TopBar data={content} />}
            <Header 
                isScrolled={isScrolled} 
                onApply={() => setIsInquiryOpen(true)}
                logo={content.site_logo}
                email={content.contact_email}
                phone={content.contact_phone}
                applyUrl={content.apply_url}
                colleges={content.colleges_list}
                placements={content.placements_list}
                research={content.research_list}
                journals={content.journals_list}
                innovations={content.innovations_list}
            />

            {/* Dedicated Hero for Notice Page */}
            <header className="relative h-[300px] bg-slate-900 flex items-center overflow-hidden">
                <div className="absolute inset-0 bg-gradient-to-r from-[#003366] via-[#003366]/80 to-transparent z-10"></div>
                <img 
                    src="https://images.unsplash.com/photo-1506784983877-45594efa4cbe?q=80&w=2000&auto=format&fit=crop" 
                    className="absolute inset-0 w-full h-full object-cover opacity-40"
                    alt="Notice Board"
                />
                <div className="max-w-7xl mx-auto px-4 relative z-20 w-full">
                    <div className="max-w-2xl px-4 md:px-0">
                        <p className="text-amber-400 font-black uppercase text-[10px] tracking-[3px] md:tracking-[6px] mb-4">Official Updates</p>
                        <h1 className="text-4xl md:text-6xl font-black text-white uppercase tracking-tighter leading-none">
                            Institutional <span className="text-amber-400">Notices</span>
                        </h1>
                        <div className="h-1.5 w-20 bg-[#cc0000] mt-6"></div>
                    </div>
                </div>
            </header>

            <main className="py-12">
                <NoticeBoard />
            </main>

            <Footer data={content} />
            <EnquiryModal isOpen={isInquiryOpen} onClose={() => setIsInquiryOpen(false)} />
        </div>
    );
};

export default Notice;
